import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';


import LoginPage      from './pages/LoginPage';
import DashboardPage  from './pages/DashboardPage';
import EmployeesPage  from './pages/EmployeesPage';
import OperationsPage from './pages/OperationsPage';
import NewWorkSession  from './pages/NewWorkSession';
import EditWorkSession from './pages/EditWorkSession';
import MachinesPage   from './pages/MachinesPage';
import ProductionPage from './pages/ProductionPage';
import StockPage      from './pages/StockPage';
import PurchasePage   from './pages/PurchasePage';
import AssetPage      from './pages/AssetPage';
import AttendancePage from './pages/AttendancePage';
import ReportsPage      from './pages/ReportsPage';
import SalesPage        from './pages/SalesPage';
import SalesOrderForm   from './pages/SalesOrderForm';
import CustomerForm     from './pages/CustomerForm';
import SalesInvoice     from './pages/SalesInvoice';
import DailyReportPage      from './pages/DailyReportPage';
import PrintDailyReportPage from './pages/PrintDailyReportPage';
import ExpensePage          from './pages/ExpensePage';
import ExpenseReportPage    from './pages/ExpenseReportPage';
import PrintExpenseReportPage from './pages/PrintExpenseReportPage';
import WorkReportPage       from './pages/WorkReportPage';
import PrintWorkReportPage from './pages/PrintWorkReportPage';
import ProductionReportPage from './pages/ProductionReportPage';
import DieselReportPage from './pages/DieselReportPage';
import PrintDieselReportPage  from './pages/PrintDieselReportPage';
import SettingsPage   from './pages/SettingsPage';
import ItemMasterPage from './pages/ItemMasterPage';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollManager() {
  const location = useLocation();
  useEffect(() => {
    // Do nothing - prevent auto scroll to top
  }, [location]);
  return null;
}

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading"><div className="spinner"/></div>;
  return user ? children : <Navigate to="/login" replace/>;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading"><div className="spinner"/></div>;
  return user ? <Navigate to="/" replace/> : children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<PublicRoute><LoginPage/></PublicRoute>}/>
          <Route path="/"                  element={<PrivateRoute><DashboardPage/></PrivateRoute>}/>
          <Route path="/employees"         element={<PrivateRoute><EmployeesPage/></PrivateRoute>}/>
          <Route path="/operations"              element={<PrivateRoute><OperationsPage/></PrivateRoute>}/>
          <Route path="/operations/new"          element={<PrivateRoute><NewWorkSession/></PrivateRoute>}/>
          <Route path="/operations/edit/:id"     element={<PrivateRoute><EditWorkSession/></PrivateRoute>}/>
          <Route path="/operations/resume/:id"   element={<PrivateRoute><EditWorkSession/></PrivateRoute>}/>
          <Route path="/machines"          element={<PrivateRoute><MachinesPage/></PrivateRoute>}/>
          <Route path="/production/blocks" element={<PrivateRoute><ProductionPage/></PrivateRoute>}/>
          <Route path="/production/stock"  element={<PrivateRoute><StockPage/></PrivateRoute>}/>
          <Route path="/sales"                  element={<PrivateRoute><SalesPage/></PrivateRoute>}/>
          <Route path="/sales/order/new"         element={<PrivateRoute><SalesOrderForm/></PrivateRoute>}/>
          <Route path="/sales/order/:id"         element={<PrivateRoute><SalesOrderForm/></PrivateRoute>}/>
          <Route path="/sales/quotation/new"     element={<PrivateRoute><SalesOrderForm isQuotation={true}/></PrivateRoute>}/>
          <Route path="/sales/customer/new"      element={<PrivateRoute><CustomerForm/></PrivateRoute>}/>
          <Route path="/sales/customer/:id"      element={<PrivateRoute><CustomerForm/></PrivateRoute>}/>
          <Route path="/sales/invoice/:id"       element={<SalesInvoice/>}/>
          <Route path="/purchase"          element={<PrivateRoute><PurchasePage/></PrivateRoute>}/>
          <Route path="/purchase/items" element={<PrivateRoute><ItemMasterPage/></PrivateRoute>}/>
          <Route path="/assets" element={<PrivateRoute><AssetPage/></PrivateRoute>}/>
          <Route path="/attendance"        element={<PrivateRoute><AttendancePage/></PrivateRoute>}/>
          <Route path="/reports"           element={<PrivateRoute><ReportsPage/></PrivateRoute>}/>
          <Route path="/reports/daily"        element={<PrivateRoute><DailyReportPage/></PrivateRoute>}/>
          <Route path="/print/daily-report"   element={<PrintDailyReportPage/>}/>
          <Route path="/expenses"             element={<PrivateRoute><ExpensePage/></PrivateRoute>}/>
          <Route path="/reports/expenses"     element={<PrivateRoute><ExpenseReportPage/></PrivateRoute>}/>
          <Route path="/print/expense-report" element={<PrintExpenseReportPage/>}/>
          <Route path="/reports/work"         element={<PrivateRoute><WorkReportPage/></PrivateRoute>}/>
          <Route path="/print/work-report" element={<PrintWorkReportPage/>}/>
          <Route path="/reports/production"   element={<PrivateRoute><ProductionReportPage/></PrivateRoute>}/>
          <Route path="/reports/diesel" element={<PrivateRoute><DieselReportPage/></PrivateRoute>}/>
          <Route path="/print/diesel-report"  element={<PrintDieselReportPage/>}/>
          <Route path="/settings"          element={<PrivateRoute><SettingsPage/></PrivateRoute>}/>
          <Route path="*"                  element={<Navigate to="/" replace/>}/>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
